import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        container: {
            layerStyle: 'page',
            width: 'full',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: {base: 'center', md: 'start'},
            borderTop: '1px',
            borderStyle: 'solid',
            borderColor: 'border.neutral.subtle',
        },
        newsletterText: {
            textStyle: 'body-xxlarge',
            color: 'text.primary',
        },
        newsletterHeader: {
            textStyle: 'head-medium',
            color: 'text.primary',
            fontWeight: 'bold',
        },
        newsletterStack: {
            alignItems: {base: 'center', lg: 'flex-start'},
            gap: remCalc(16),
            w: 'full',
            maxW: remCalc(572),
        },
        newsletterFlex: {
            flexDirection: {base: 'column', md: 'row'},
            justifyContent: 'center',
            alignItems: 'center',
            gap: remCalc(24),
            minW: {base: 'auto', xl: remCalc(926)},
        },
        benefitContainer: {
            background: 'background.base.default',
        },
        newsletterContainer: {
            background: 'background.light-blue',
        },
        preFooterContainer: {
            gap: '0',
        },
        benefitBarHeader: {
            textStyle: 'body-small',
            color: 'foreground.neutral.default',
            fontWeight: 'medium',
        },
        benefitBarText: {
            textStyle: 'body-small',
            color: 'foreground.neutral.muted',
            fontWeight: 'normal',
            width: 'full',
        },
        benefitBarIcons: {
            color: 'background.dark',
            boxSize: remCalc(20),
            alignSelf: 'flex-start',
        },
        benefitBarStack: {
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: {base: 'xsmall.base', md: 'xsmall.md', lg: 'xsmall.lg', xl: 'xsmall.xl'},
            w: 'full',
            maxW: {base: 'unset', lg: remCalc(328)},
            paddingY: {base: 'small.base', md: 'small.md', lg: remCalc(0), xl: remCalc(0)},
        },
        benefitBarBox: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: {base: 'micro.base', md: 'micro.md', lg: 'micro.lg', xl: 'micro.xl'},
            textAlign: 'left',
            paddingRight: {
                base: 'xxsmall.base',
                md: 'xxsmall.md',
                lg: 'xxsmall.lg',
                xl: 'xxsmall.xl',
            },
        },
        benefitBarContainer: {
            w: 'full',
            maxW: remCalc(1432),
            marginX: 'auto',
            justifyContent: 'space-between',
            flexDirection: {base: 'column', lg: 'row'},
            alignItems: 'flex-start',
            gap: {base: 'medium.base', md: 'medium.md', lg: 'medium.lg', xl: 'medium.xl'},
            paddingY: {
                base: 'xsmall.lg',
                md: 'xsmall.lg',
                lg: 'medium.lg',
                xl: 'medium.xl',
            },
        },
        newsletterButton: {
            w: 'full',
            maxW: {base: 'auto', lg: remCalc(330)},
            alignSelf: 'center',
        },
    },
}
